module.exports = __webpack_public_path__ + "img/enroll_vb_jbsmd.0f4d3c00.png";